import type { ITenantLanguage } from '@/shared/api/types/tenant-types'
import { useMemo } from 'react'
import { useLanguageFilter } from '@/shared/hooks/use-language-filter'

/**
 * Language used to fetch and label POIs/destinations in the tour form.
 *
 * VI: `useLanguageFilter` chỉ set ngôn ngữ trong effect nên frame đầu có thể trống; fallback về ngôn ngữ mặc định của tenant rồi đến option đầu để query không chạy với language rỗng. | EN: `useLanguageFilter` only sets the language in an effect, so the first frame can be empty; fall back to the tenant default, then the first option, so queries never run with an empty language.
 */
export function useTourPoiLanguage(tenantLanguageItems: ITenantLanguage[]) {
  const { selectedLanguageCode, setSelectedLanguageCode, languageOptions } =
    useLanguageFilter(tenantLanguageItems)

  const effectiveLanguageCode = useMemo(() => {
    if (selectedLanguageCode) {
      return selectedLanguageCode
    }
    return languageOptions.find((item) => item.isDefault)?.value ?? languageOptions[0]?.value ?? ''
  }, [languageOptions, selectedLanguageCode])

  return { languageOptions, effectiveLanguageCode, setSelectedLanguageCode }
}
